import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-creditbureaudetails',
  templateUrl: './creditbureaudetails.component.html',
  styleUrls: ['./creditbureaudetails.component.css']
})
export class CreditbureaudetailsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
